import {createAction, props} from '@ngrx/store';
import {PlanejadoExecutado} from '~utils/planejado-executado';

export enum FeatureResumoActionsTypes {
  SetDistanciaRoterizada = '[Resumo] setDistanciaRoterizada',
  SetRotasGeradas = '[Resumo] setRotasGeradas',
  SetAtendimentos = '[Resumo] setAtendimentos',
  SetClientesAtendidos = '[Resumo] setClientesAtendidos',
  SetCaminhoesUtilizados = '[Resumo] setCaminhoesUtilizados',
  SetPedidosNaoAtendidos = '[Resumo] setPedidosNaoAtendidos',
  Reiniciar = '[Resumo] reiniciar'
}

export const resumoSetDistanciaRoterizada = createAction(
  FeatureResumoActionsTypes.SetDistanciaRoterizada,
  props<PlanejadoExecutado>()
);

export const resumoSetRotasGeradas = createAction(
  FeatureResumoActionsTypes.SetRotasGeradas,
  props<PlanejadoExecutado>()
);

export const resumoSetAtendimentos = createAction(
  FeatureResumoActionsTypes.SetAtendimentos,
  props<PlanejadoExecutado>()
);

export const resumoSetClientesAtendidos = createAction(
  FeatureResumoActionsTypes.SetClientesAtendidos,
  props<PlanejadoExecutado>()
);

export const resumoSetCaminhoesUtilizados = createAction(
  FeatureResumoActionsTypes.SetCaminhoesUtilizados,
  props<PlanejadoExecutado>()
);

export const resumoSetPedidosNaoAtendidos = createAction(
  FeatureResumoActionsTypes.SetPedidosNaoAtendidos,
  props<PlanejadoExecutado>()
);

export const resumoReiniciar = createAction(
  FeatureResumoActionsTypes.Reiniciar
);

